import japanNightWallpaper from "./japanNightWallpaper.jpg";
import lineRiderSynthWallpaper from "./lineRiderSynthWallpaper.jpg";
import nightCityWallpaper from "./nightCityWallpaper.jpg";
import pinkSunWallpaper from "./pinkSunWallpaper.jpg";
import redEclipseWallpaper from "./redEclipseWallpaper.jpg";
import synthMountainWallpaper from "./synthMountainWallpaper.jpg";
import synthWaveWallpaper from "./synthWaveWallpaper.jpg";
import stoneCubismWallpaper from "./stoneCubismWallpaper.jpg";
import sunsetMinimalistWallpaper from "./sunsetMinimalistWallpaper.jpg";
import spaceNightSkyWallpaper from "./spaceNightSkyWallpaper.jpg";

export {
  lineRiderSynthWallpaper,
  nightCityWallpaper,
  pinkSunWallpaper,
  synthMountainWallpaper,
  spaceNightSkyWallpaper,
};

export const MOOD_WALLPAPERS = [
  japanNightWallpaper,
  redEclipseWallpaper,
  synthWaveWallpaper,
  stoneCubismWallpaper,
  sunsetMinimalistWallpaper,
];
